import type { MutateSelectedFailure } from '../../hooks/useBillingCycles';
import { getBusinessErrorMessage } from '../../utils/apiErrorDetail';

type ShowErrorFn = (title: string, message: string) => void;

const CLAIM_SEND_FALLBACK =
  'Unexpected error occurred. Please try again or contact support.';

export const showSendBillingCycleFailures = (
  failures: MutateSelectedFailure[],
  showError: ShowErrorFn
) => {
  const lines = failures.map(failure => {
    const reason =
      getBusinessErrorMessage(failure.error) ?? CLAIM_SEND_FALLBACK;
    if (reason === CLAIM_SEND_FALLBACK) {
      const id = failure.mrn
        ? `${failure.name} (MRN ${failure.mrn})`
        : failure.name;
      return `• ${id}: ${reason}`;
    }
    return `• ${reason}`;
  });

  showError(
    'Some billing cycles failed to send',
    `The following billing cycles could not be sent. Fix the chart and try again:\n${lines.join('\n')}`
  );
};
